import auth from "../../../services/auth/AuthProvider";

export const userProfile = (state = auth.getProfile(), action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return action.userProfile;
    default:
      return state;
  }
};

export const getUserProfile = (state) => state;
